import { render, staticRenderFns } from "./advancePersonalDetailsSettings.vue?vue&type=template&id=6ca75b50"
import script from "./advancePersonalDetailsSettings.vue?vue&type=script&lang=js"
export * from "./advancePersonalDetailsSettings.vue?vue&type=script&lang=js"
import style0 from "./advancePersonalDetailsSettings.vue?vue&type=style&index=0&id=6ca75b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports